import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { AccountModelViewClient } from "../../../../../../../../Wrap/Api/Transaction/AccountModelView";
import { AccountModelPortfolioDispatcher } from "../Store/Variable";

export class AccountModelPortfolioAction {
    public static getAccountModelPortfolio(hierarchyId: string, cashSpecific: boolean): void {
        const client = new AccountModelViewClient();
        const promise = client.get(hierarchyId, cashSpecific);

        promise.onSuccess((result) => {
            AccountModelPortfolioDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {
            AccountModelPortfolioDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
